// extracted by mini-css-extract-plugin
module.exports = {"cart":"CartIcon__cart___3E0xZ","cartImage":"CartIcon__cartImage___1K4Dd","quantity":"CartIcon__quantity___1l9rY","light":"CartIcon__light___3Ksl1"};